import { useSearchParams } from 'next/navigation'

import { useEffect } from 'react'
import getConfig from 'next/config'

import ChooseSimPage from '@/components/pages/ChooseSim'
import MainLayout from '@/layouts/Main'

import { mfeRedirect } from '@/utils/mfeRedirect'
import { MemberDetails } from '@/api/member/member.types'

import type { NextPage } from 'next'

const { publicRuntimeConfig } = getConfig()

type ChooseSimProps = {
  memberDetails?: MemberDetails
}

const ChooseSim: NextPage<ChooseSimProps> = ({ memberDetails }) => {
  const searchParams = useSearchParams()
  const sku = searchParams.get('sku')

  useEffect(() => {
    if (sku === null) mfeRedirect('')
  }, [sku])

  if (sku === null) return null

  return (
    <MainLayout memberDetails={memberDetails}>
      <ChooseSimPage
        enableSnowplow={publicRuntimeConfig.FF_ENABLE_SNOWPLOW}
        isLoggedIn={Boolean(memberDetails)}
        sku={sku}
      />
    </MainLayout>
  )
}

export default ChooseSim
